import { Dispatch } from "redux";
import { Action } from "../actions";
import { ActionType } from "../action-types";
import type { Airline, Place, User } from "../../my-type";

export const updateUser = (user: User | null) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_USER,
      payload: user,
    });
  }
}

export const updatePlace = (places: Place[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_PLACE,
      payload: places,
    });
  }
}

export const updateAirlines = (airlines: Airline[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_AIRLINE,
      payload: airlines,
    });
  }
}
